module.exports = __webpack_public_path__ + "media/images/athletes/3411-6a29737f5d47d8d1b3b3f3f2ad237c09.png";